import { Injectable, inject } from '@angular/core';
import { HowdenHttpClientService } from '@howdeniberia/core-front';
import { Observable } from 'rxjs';
import { APP_CONSTANTS } from 'src/app/core/constants/general-constants';
import { ICredentialDto } from 'src/app/core/models/api/credential-dto';
import { ICredentialDataFilterDto } from 'src/app/core/models/api/credential-filter-dto';
import { INewCredentialDto } from 'src/app/core/models/api/new-credential-dto';
import { IDeleteCredentialDto } from '../../models/api/delete-credential-dto';
import { ClavesCiasContract } from './claves-cias-contract';

@Injectable({
  providedIn: 'root'
})
export class ClavesCiasApiService implements ClavesCiasContract {
  private httpClient = inject(HowdenHttpClientService);

  apiName = APP_CONSTANTS.API_CLAVES_CIAS_NAME;
  basePath = 'api/credentials';

  public getCredentials(): Observable<ICredentialDto[]> {
    return this.httpClient.get<ICredentialDto[]>(this.apiName, this.basePath);
  }

  public registerCredential(newCredentialDto: INewCredentialDto): Observable<ICredentialDto> {
    return this.httpClient.post<ICredentialDto>(this.apiName, this.basePath, newCredentialDto);
  }

  public findCredentials(filter: ICredentialDataFilterDto): Observable<ICredentialDto[]> {
    const path = `${this.basePath}/find`;
    return this.httpClient.post<ICredentialDto[]>(this.apiName, path, filter);
  }

  public updateCredential(credentialDto: ICredentialDto): Observable<ICredentialDto> {
    return this.httpClient.put<ICredentialDto>(this.apiName, this.basePath, credentialDto);
  }

  public reactivateCredential(credentialId: number): Observable<boolean> {
    const path = `${this.basePath}/${credentialId}`;
    return this.httpClient.put<boolean>(this.apiName, path);
  }

  public deleteCredential(deleteCredentialDto: IDeleteCredentialDto): Observable<ICredentialDto> {
    return this.httpClient.delete<ICredentialDto>(this.apiName, this.basePath, { body: deleteCredentialDto });
  }
}
